// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"PaymentSpeedChart_formWrapper__3uTZ8","chartWrapper":"PaymentSpeedChart_chartWrapper__1zDTi"};